import React from 'react';

interface IOptionalValueProps {
  text?: string | null;
}

export const OptionalValue: React.FC<IOptionalValueProps> = ({ text }) => {
  return <>{text || '-'}</>;
};
